import axiosInstance from '../axiosInterceptor/axiosInstance'
import decodeJwt from 'jwt-decode'
import localStorageIds from '../../utils/constants/localStorageIds'

const getUserInvitations = async () => {
  const token = localStorage.getItem(localStorageIds.TOKEN)
  const { sub: userId } = token ? decodeJwt(token) : {}
  return axiosInstance.get(`v1/users/${userId}/invitations`)
}

export default getUserInvitations
